export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGIN_FAILURE = 'USER_LOGIN_FAILURE';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_MFA_REQUIRED = 'USER_LOGIN_MFA_REQUIRED';
export const USER_LOGIN_WITH_MFACODE = 'USER_LOGIN_WITH_MFACODE';
export const CLEAR_WAITING_FOR_MFA = 'CLEAR_WAITING_FOR_MFA';
